import { FC, useCallback } from "react"
import { useNavigate } from "react-router-dom"

import LoanProgramCardHeader from "./header"
import LoanProgramCardBody from "./body"
import { PricingSet } from "../../../../types"

interface LoanProgramCardProps {
  /** Full set, including pricing_profiles, from the list query. */
  pricingSet: PricingSet
  isDefault?: boolean
}

const LoanProgramCard: FC<LoanProgramCardProps> = ({
  pricingSet,
  isDefault
}) => {
  const navigate = useNavigate()

  const handleClick = useCallback(
    (id: string) => {
      navigate(`/loan-programs/${id}`)
    },
    [navigate]
  )

  return (
    <li className="col-span-1 flex flex-col bg-white min-h-[284px]">
      <LoanProgramCardHeader pricingSet={pricingSet} onClick={handleClick} />
      <LoanProgramCardBody pricingSet={pricingSet} isDefault={isDefault} />
    </li>
  )
}

export default LoanProgramCard
